import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AlreadyProcessedComponent } from './pages/already-processed/already-processed.component';
import { ExpiredComponent } from './pages/expired/expired.component';

const routes: Routes = [
  {
    path: 'already-processed',
    component: AlreadyProcessedComponent,
  },
  {
    path: 'expired',
    component: ExpiredComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MessagesRoutingModule {}
